// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1KWrn","search":"Settings_search__ejahW","filter":"Settings_filter__1flxA"};